import { ValidationType } from '../enums/validation-type.enum';
import { ValidationError } from 'class-validator';

export class DishValidationError extends ValidationError {
  type: ValidationType;
  children: DishValidationError[];
}
